
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import TranslatedText from '@/TranslatedText';

const NewsletterSection: React.FC = () => {
  return (
    <motion.div 
      className="bg-gradient-to-r from-ahavex-blue to-blue-600 rounded-2xl p-6 md:p-8 text-white" 
      initial={{opacity: 0, y: 20}} 
      whileInView={{opacity: 1, y: 0}} 
      transition={{duration: 0.6}} 
      viewport={{once: true}}
    >
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl font-bold mb-3">
          <TranslatedText text="Stay Connected" />
        </h2>
        <p className="text-sm mb-5 opacity-90">
          <TranslatedText 
            text="Subscribe to our newsletter for the latest community updates, upcoming events, and business opportunities."
          />
        </p>
        <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <Input 
            type="email" 
            placeholder="Enter your email" 
            className="bg-white/20 border-white/40 text-white placeholder:text-white/70 h-8 text-sm" 
          />
          <Button className="bg-white text-ahavex-blue hover:bg-white/90 text-xs h-8">
            <TranslatedText text="Subscribe" />
          </Button>
        </div>
      </div>
    </motion.div>
  );
};

export default NewsletterSection;
